import React from 'react';
import { FaTimes, FaCalendar } from 'react-icons/fa';

interface NewsModalProps {
  isOpen: boolean;
  onClose: () => void;
  article: {
    title: string;
    date: string;
    excerpt: string;
    fullText: string;
  } | null;
}

const NewsModal: React.FC<NewsModalProps> = ({ isOpen, onClose, article }) => {
  if (!isOpen || !article) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="glass-effect rounded-2xl p-8 max-w-3xl w-full max-h-[90vh] overflow-y-auto animate-slide-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-4">
              <FaCalendar className="text-accent-primary" />
              <span className="text-dark-muted">{article.date}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gradient">
              {article.title}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-dark-card rounded-lg transition-colors flex-shrink-0"
            aria-label="Close"
          >
            <FaTimes className="text-2xl text-dark-muted hover:text-dark-text" />
          </button>
        </div>

        <div className="prose prose-invert max-w-none">
          <p className="text-lg text-dark-muted leading-relaxed mb-4">
            {article.excerpt}
          </p>
          <div className="text-dark-muted leading-relaxed whitespace-pre-line">
            {article.fullText}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-dark-border">
          <button
            onClick={onClose}
            className="px-6 py-3 bg-gradient-to-r from-accent-primary to-accent-secondary hover:opacity-90 rounded-lg font-semibold transition-opacity"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewsModal;

